import { apiService } from './apiService';

const invalidatesCompanyOverview = { invalidatesTags: ['CompanyOverview' as const] };
const providesPermissionGroups = { providesTags: ['PermissionGroups' as const] };
const providesCompanyUsers = { providesTags: ['CompanyUsers' as const] };
// A group's privileges show up in user lists and in /me, so a change to a group refreshes both.
const invalidatesGroups = {
  invalidatesTags: ['PermissionGroups' as const, 'CompanyUsers' as const, 'UserMe' as const],
};
const invalidatesMemberships = { invalidatesTags: ['CompanyUsers' as const, 'UserMe' as const] };

apiService.enhanceEndpoints({
  endpoints: {
    campaignControllerCampaign: {
      providesTags: (_result, _error, arg) => [{ type: 'Campaign', id: arg.id }],
    },
    handoffRuleCreateControllerExecute: {
      invalidatesTags: [{ type: 'Campaign' }],
    },
    companyOverviewControllerGetCompanyOverview: {
      providesTags: ['CompanyOverview'],
    },
    toolListControllerAgentTollList: {
      providesTags: (_result, _error, arg) => [{ type: 'AgentTools', id: arg.id }],
    },
    toolCreateControllerCreateAgentTool: {
      invalidatesTags: (_result, _error, arg) => [{ type: 'AgentTools', id: arg.id }],
    },
    toolUpdateControllerCreateAgentTool: {
      invalidatesTags: (_result, _error, arg) => [{ type: 'AgentTools', id: arg.id }],
    },
    toolDeleteControllerCreateAgentTool: {
      invalidatesTags: (_result, _error, arg) => [{ type: 'AgentTools', id: arg.id }],
    },
    campaignCreateControllerCampaignCreate: invalidatesCompanyOverview,
    campaignDeleteControllerDeleteCampaign: invalidatesCompanyOverview,
    campaignRunControllerCampaignRun: invalidatesCompanyOverview,
    campaignStopControllerCampaignStop: invalidatesCompanyOverview,
    userMeControllerUserMe: {
      providesTags: ['UserMe'],
    },
    userUpdateControllerUpdate: invalidatesMemberships,
    userCreateControllerCreateUser: invalidatesMemberships,
    permissionGroupListControllerList: providesPermissionGroups,
    permissionGroupListControllerListForManager: providesPermissionGroups,
    userListControllerList: providesCompanyUsers,
    userListControllerListForManager: providesCompanyUsers,
    permissionGroupCreateControllerCreate: invalidatesGroups,
    permissionGroupCreateControllerCreateForManager: invalidatesGroups,
    permissionGroupUpdateControllerUpdate: invalidatesGroups,
    permissionGroupUpdateControllerUpdateForManager: invalidatesGroups,
    permissionGroupDeleteControllerDelete: invalidatesGroups,
    permissionGroupDeleteControllerDeleteForManager: invalidatesGroups,
    userPermissionGroupAttachControllerAttach: invalidatesMemberships,
    userPermissionGroupAttachControllerAttachForManager: invalidatesMemberships,
    userPermissionGroupDetachControllerDetach: invalidatesMemberships,
    userPermissionGroupDetachControllerDetachForManager: invalidatesMemberships,
  },
});

export { apiService };
